// import BMap from 'BMap'
// import BMapLib from 'BMapLib'
const ClusterFun = {
  setLayer: async function (map, data, markerList, _this, removeToolBar) {
    let flag = null
    let pt = null
    // let viewPortList = []
    let carKeyList = [5, 23, 24, 25, 26, 27, 28, 29, 32, 33, 42, 43, 40, 45]
    let shipList = [6, 31]
    _this.icon = null
    if (!_this.markerCluster) {
      _this.markerCluster = new BMapLib.MarkerClusterer(map, { markers: markerList })
      _this.markerCluster.setMaxZoom(9)
      _this.markerCluster.setStyles([
        { size: new BMap.Size(35, 35), url: require('../../assets/images/clusterLayerImg/cluster1.png') },
        { size: new BMap.Size(35, 35), url: require('../../assets/images/clusterLayerImg/cluster2.png') },
        { size: new BMap.Size(35, 35), url: require('../../assets/images/clusterLayerImg/cluster3.png') }
      ])
    }
    if (data.length > 0 && data.length >= markerList.length) {
      // _this.test.push()
      // 控制不遍历新增的markerList设备
      let markerListLength = markerList.length
      for (let i = 0; i < data.length; i++) {
        _this.test.push(data[i])
        // await _this.popupGeocoder(data[i].lLonBd09, data[i].lLatBd09)
        let lat = data[i].lLatBd09
        let lng = data[i].lLonBd09
        if (markerListLength > 0) {
          for (let n = 0; n < markerListLength; n++) {
            if (data[i].devId === markerList[n].id) {
              // 更新点坐标、方向
              _this.icon = _this.$cautionIconFun.setIconAndPopupHtmlBDMap(_this, data[i])
              if (data[i].cId !== null && data[i].cId !== '' && data[i].devModel === 30) {
                markerList[n].setIcon(new BMap.Icon(require('../../assets/images/高精度/报警.png'), new BMap.Size(40, 40), {
                  imageSize: new BMap.Size(40, 40)
                }))
              }
              if (_this.ifInfoBoxShow === true && _this.infoBox._opts.id === data[i].devId) {
                let electric = null
                if (data[i].lElectricQuantity * 1 > 90) {
                  electric = require('../../assets/images/电池/100.png')
                } else if (data[i].lElectricQuantity * 1 > 50) {
                  electric = require('../../assets/images/电池/50-90.png')
                } else if (data[i].lElectricQuantity * 1 > 20) {
                  electric = require('../../assets/images/电池/20-50.png')
                } else {
                  electric = require('../../assets/images/电池/0-20.png')
                }
                // 百度地图infobox不能直接调用vue method方法，调用window.function 丢失精度，这里分段传参
                let id1 = data[i].devId.slice(0, data[i].devId.length - 10)
                let id2 = data[i].devId.slice(-10)
                let html = '<div style="width: 300px; height: 260px; background-color: #FFFFFF; border-radius: 5px; box-shadow: 3px 3px 3px 3px #e8e8e8;">' +
                  '<div style="width: 100%; height: 35px; border-radius: 5px 5px 0 0; border-bottom: #f1f1f1 solid 1px">' +
                  '<table>' +
                  '<tr>' +
                  // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/电备份 3@2x.png') + '" style="height: 12px; width: 12px">15</td>' +
                  // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/编组 6@2x.png') + '" style="height: 12px; width: 12px">5</td>' +
                  '<td style="padding: 0">' +
                  '<div style="float: left; margin-left: 5px"><img src="' + electric + '" style="height: 20px; width: 20px; margin-top: 5px"></div><div style="float: left; line-height: 30px; font-size: 12px; margin-left: 5px">' + data[i].lElectricQuantity + '%</div></td>' +
                  // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/信号备份 2@2x.png') + '" style="height: 12px; width: 12px"></td>' +
                  // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/SIM 流量卡.png') + '" style="height: 12px; width: 12px"></td>' +
                  '</tr>' +
                  '</table>' +
                  '</div>' +
                  '<div style="width: 70%; float: right; padding: 10px 20px 0 20px">' +
                  '<table>' +
                  '<tr>' +
                  '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备名称:</span></td>' +
                  '<td><span style="font-size: 12px">' + data[i].devName + '</td>' +
                  '</tr>' +
                  '<tr>' +
                  '<tr>' +
                  '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备状态:</span></td>' +
                  '<td><span style="font-size: 12px">' + _this.lImmediatelyStatusDic(data[i].status) + '</td>' +
                  '</tr>' +
                  '<tr>' +
                  '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备编号:</span></td>' +
                  '<td><span style="font-size: 12px">' + data[i].devImei + '</td>' +
                  '</tr>' +
                  '<tr>' +
                  '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">定位时间:</span></td>' +
                  '<td><span style="font-size: 12px">' + data[i].lRecordTime + '</td>' +
                  '</tr>' +
                  '<tr>' +
                  '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">通讯时间:</span></td>' +
                  '<td><span style="font-size: 12px">' + data[i].createTime + '</td>' +
                  '</tr>' +
                  '</table>' +
                  '</div>' +
                  '<div style="width: 90%; height: 60px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px; margin-top: 130px; padding: 0 15px">' +
                  // '<span style="font-size: 12px; padding: 0 10px">GPS(BDS) ' + _this.popupGeocoderAddress + '</span>' +
                  '</div>'
                let html2 = '<div style="width: 100%; height: 35px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px">' +
                  '<table>' +
                  '<tr>' +
                  '<td style="padding: 2px 8px; cursor: pointer">' +
                  '<img src="' +
                  require('../../assets/images/function/geofence.svg') +
                  '" title="电子围栏" style="height: 20px; width: 20px" onclick="jumpToFence(' + data[i].devId + ')"></td>' +
                  '<td style="padding: 2px 8px; cursor: pointer">' +
                  '<img src="' +
                  require('../../assets/images/function/tracks.svg') +
                  '" title="轨迹回放" style="height: 20px; width: 20px" onclick="jumpToReplay(' + data[i].devImei + ')"></td>' +
                  '<td style="padding: 2px 8px; cursor: pointer">' +
                  '<img src="' +
                  require('../../assets/images/function/rt-monitor.svg') +
                  '" title="实时追踪" style="height: 20px; width: 20px" onclick="jumpToTracking(' + data[i].devImei + ')"></td>' +
                  '<td style="padding: 2px 8px; cursor: pointer">' +
                  '<img src="' +
                  require('../../assets/images/menuIcon/车辆管理.png') +
                  '" title="告警记录" style="height: 20px; width: 20px" onclick="jumpToCaution(\'' + data[i].devName + '\')"></td>' +
                  '<td style="padding: 2px 8px; cursor: pointer">' +
                  '<img src="' +
                  require('../../assets/images/warningIcon-menu.png') +
                  '" title="围栏告警" style="height: 20px; width: 20px" onclick="jumpToFenceInfo(' + id1 + ',' + id2 + ')"></td>' +
                  '<td style="padding: 2px 8px; cursor: pointer">' +
                  '<img src="' +
                  require('../../assets/images/menuIcon/统计分析.png') +
                  '" title="里程统计" style="height: 20px; width: 20px" onclick="jumpToMiles(' + data[i].devImei + ')"></td>' +
                  '<td style="padding: 2px 8px; cursor: pointer">' +
                  '<img src="' +
                  require('../../assets/images/index/反馈.png') +
                  '" title="详情" style="height: 20px; width: 20px" onclick="jumpToDetails(' + data[i].devImei + ')"></td>' +
                  '</tr>' +
                  '</table>' +
                  '</div>'
                let html3 = '</div>'
                if (removeToolBar) {
                  html = html + html3
                } else {
                  html = html + html2 + html3
                }
                _this.infoBox.setContent(html)
                _this.infoBox.setPosition(new BMap.Point(lng, lat))
              }
              markerList[n].setPosition(new BMap.Point(lng, lat))
              markerList[n].setIcon(_this.icon)
              if (carKeyList.indexOf(data[i].devModel) > -1 || shipList.indexOf(data[i].devModel) > -1) {
                markerList[n].setRotation(data[i].lDirection)
              }
              flag = true
              break
            } else {
              flag = false
            }
          }
        }
        if (!flag) {
          // 新建点
          // await _this.popupGeocoder(data[i].lLonBd09, data[i].lLatBd09)
          pt = new BMap.Point(lng, lat)
          _this.icon = _this.$cautionIconFun.setIconAndPopupHtmlBDMap(_this, data[i])
          let marker = new BMap.Marker(pt, {
            icon: _this.icon
          })
          marker.addEventListener('click', () => { _this.showPopup(data[i]) })
          markerList.push(marker)
          if (carKeyList.indexOf(data[i].devModel) > -1 || shipList.indexOf(data[i].devModel) > -1) {
            marker.setRotation(data[i].lDirection)
          }
          marker.id = data[i].devId
          _this.markerCluster.addMarker(marker)
          // _this.showPopup(data[i])
        }
      }
      // for (let item in markerList) {
      //   viewPortList.push(markerList[item].point)
      //   console.log(4)
      // }
      // 视角调整
      // if (_this.ifInfoBoxShow === false) {
      //   _this.map.setViewport(viewPortList, {})
      // }
    } else if (data.length < markerList.length && data.length > 0) {
      let del = null
      // 用于删除markerList
      let removeDevIds = []
      for (let m = 0; m < markerList.length; m++) {
        for (let j = 0; j < data.length; j++) {
          // await _this.popupGeocoder(data[j].lLonBd09, data[j].lLatBd09)
          let lng = data[j].lLonBd09
          let lat = data[j].lLatBd09
          if (data[j].devId === markerList[m].id) {
            // 更新点
            _this.icon = _this.$cautionIconFun.setIconAndPopupHtmlBDMap(_this, data[j])
            if (data[j].cId !== null && data[j].cId !== '' && data[j].devModel === 30) {
              markerList[m].setIcon(new BMap.Icon(require('../../assets/images/高精度/报警.png'), new BMap.Size(40, 40), {
                imageSize: new BMap.Size(40, 40)
              }))
            }
            if (_this.ifInfoBoxShow === true && _this.infoBox._opts.id === data[j].devId) {
              let electric = null
              if (data[j].lElectricQuantity * 1 > 90) {
                electric = require('../../assets/images/电池/100.png')
              } else if (data[j].lElectricQuantity * 1 > 50) {
                electric = require('../../assets/images/电池/50-90.png')
              } else if (data[j].lElectricQuantity * 1 > 20) {
                electric = require('../../assets/images/电池/20-50.png')
              } else {
                electric = require('../../assets/images/电池/0-20.png')
              }// 百度地图infobox不能直接调用vue method方法，调用window.function 丢失精度，这里分段传参
              let id1 = data[j].devId.slice(0, data[j].devId.length - 10)
              let id2 = data[j].devId.slice(-10)
              let html = '<div style="width: 300px; height: 260px; background-color: #FFFFFF; border-radius: 5px; box-shadow: 3px 3px 3px 3px #e8e8e8;">' +
                '<div style="width: 100%; height: 35px; border-radius: 5px 5px 0 0; border-bottom: #f1f1f1 solid 1px">' +
                '<table>' +
                '<tr>' +
                // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/电备份 3@2x.png') + '" style="height: 12px; width: 12px">15</td>' +
                // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/编组 6@2x.png') + '" style="height: 12px; width: 12px">5</td>' +
                '<td style="padding: 0">' +
                '<div style="float: left; margin-left: 5px"><img src="' + electric + '" style="height: 20px; width: 20px; margin-top: 5px"></div><div style="float: left; line-height: 30px; font-size: 12px; margin-left: 5px">' + data[j].lElectricQuantity + '%</div></td>' +
                // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/信号备份 2@2x.png') + '" style="height: 12px; width: 12px"></td>' +
                // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../assets/images/SIM 流量卡.png') + '" style="height: 12px; width: 12px"></td>' +
                '</tr>' +
                '</table>' +
                '</div>' +
                '<div style="width: 70%; float: right; padding: 10px 20px 0 20px">' +
                '<table>' +
                '<tr>' +
                '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备名称:</span></td>' +
                '<td><span style="font-size: 12px">' + data[j].devName + '</td>' +
                '</tr>' +
                '<tr>' +
                '<tr>' +
                '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备状态:</span></td>' +
                '<td><span style="font-size: 12px">' + _this.lImmediatelyStatusDic(data[j].status) + '</td>' +
                '</tr>' +
                '<tr>' +
                '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备编号:</span></td>' +
                '<td><span style="font-size: 12px">' + data[j].devImei + '</td>' +
                '</tr>' +
                '<tr>' +
                '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">定位时间:</span></td>' +
                '<td><span style="font-size: 12px">' + data[j].lRecordTime + '</td>' +
                '</tr>' +
                '</table>' +
                '</div>' +
                '<div style="width: 90%; height: 70px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px; margin-top: 120px; padding: 0 15px">' +
                // '<span style="font-size: 12px; padding: 0 10px">GPS(BDS) ' + _this.popupGeocoderAddress + '</span>' +
                '</div>' +
                '<div style="width: 100%; height: 35px; border-radius: 0 0 5px 5px; border-top: #f1f1f1 dashed 1px">' +
                '<table>' +
                '<tr>' +
                '<td style="padding: 2px 8px; cursor: pointer">' +
                '<img src="http://qiniu.lnbeidou.com/lnbdptmenu5500dzwl.png" title="电子围栏" style="height: 20px; width: 20px" onclick="jumpToFence(' + data[j].devId + ')"></td>' +
                '<td style="padding: 2px 8px; cursor: pointer">' +
                '<img src="http://qiniu.lnbeidou.com/lnbdptmenu5500gjhf.png" title="轨迹回放" style="height: 20px; width: 20px" onclick="jumpToReplay(' + data[j].devImei + ')"></td>' +
                '<td style="padding: 2px 8px; cursor: pointer">' +
                '<img src="http://qiniu.lnbeidou.com/lnbdptmenu5500sszz.png" title="实时追踪" style="height: 20px; width: 20px" onclick="jumpToTracking(' + data[j].devImei + ')"></td>' +
                '<td style="padding: 2px 8px; cursor: pointer">' +
                '<img src="http://qiniu.lnbeidou.com/callthepolice.png" title="告警记录" style="height: 20px; width: 20px" onclick="jumpToCaution(\'' + data[j].devName + '\')"></td>' +
                '<td style="padding: 2px 8px; cursor: pointer">' +
                '<img src="http://qiniu.lnbeidou.com/Fencealarm.png" title="围栏告警" style="height: 20px; width: 20px" onclick="jumpToFenceInfo(' + id1 + ',' + id2 + ')"></td>' +
                '<td style="padding: 2px 8px; cursor: pointer">' +
                '<img src="http://qiniu.lnbeidou.com/Mileagestatistics.png" title="里程统计" style="height: 20px; width: 20px" onclick="jumpToMiles(' + data[j].devImei + ')"></td>' +
                '<td style="padding: 2px 8px; cursor: pointer">' +
                '<img src="http://qiniu.lnbeidou.com/detail.png" title="详情" style="height: 20px; width: 20px" onclick="jumpToDetails(' + data[j].devImei + ')"></td>' +
                '</tr>' +
                '</table>' +
                '</div>' +
                '</div>'
              _this.infoBox.setContent(html)
              _this.infoBox.setPosition(new BMap.Point(lng, lat))
            }
            markerList[m].setPosition(new BMap.Point(lng, lat))
            if (carKeyList.indexOf(data[j].devModel) > -1 || shipList.indexOf(data[j].devModel) > -1) {
              markerList[m].setRotation(data[j].lDirection)
            }
            del = true
            break
          } else {
            del = false
          }
        }
        if (!del) {
          if (_this.infoBox !== null) {
            _this.infoBox.close()
          }
          _this.markerCluster.removeMarker(markerList[m])
          removeDevIds.push(markerList[m].id)
        }
      }
      // 删除markerList中取消勾选的设备
      for (let a = 0; a < markerList.length; a++) {
        if (removeDevIds.indexOf(markerList[a].id) > -1) {
          markerList.splice(a, 1)
        }
      }
      // for (let item in markerList) {
      //   viewPortList.push(markerList[item].point)
      // }
      // if (_this.ifInfoBoxShow === false) {
      //   _this.map.setViewport(viewPortList, {})
      // }
    } else {
      // 清空地图页面监听器已拦截无数据情况，这里只做代码结构
      markerList.splice(0, markerList.length)
      _this.markerCluster.clearMarkers(markerList)
    }
    // if (_this.ifInfoBoxShow === false) {
    //   _this.map.setViewport(viewPortList, {
    //     delay: 0
    //   })
    // }
  }
}
export default ClusterFun



// WEBPACK FOOTER //
// ./src/javascript/Bdmap/clusterLayerJs.js